import { render } from "./pod.vue?vue&type=template&id=3eee6dfc&ts=true"
import script from "./pod.vue?vue&type=script&lang=ts"
export * from "./pod.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__